module.exports = __webpack_public_path__ + "static/media/toolkit-favorite-placeholder.66e9dbcc.svg";